<template>
    <div
        class="TableFilter"
        v-if="show"
    >
        <span><b>Filtered By {{ type }}</b>: {{ term }}</span>
        <v-btn
            x-small
            color="secondary"
            @click="clearFilter"
        >
            <v-icon
                left
                x-small
            >
                fas fa-times-circle
            </v-icon>
            Clear
        </v-btn>
    </div>
</template>

<script>
import { EventBus } from '@/store/eventBus';

export default {
    props: [
        'indexType',
        'show',
        'type',
        'term'
    ],

    methods: {
        clearFilter() {
            EventBus.$emit(`${this.indexType}+ClearIndexFilter`);
        }
    }
};
</script>

<style lang="scss">
.TableFilter {
    display: flex;
    flex-flow: row wrap;
    justify-content: space-between;
    align-content: center;
    align-items: center;
    flex: 0 0 100%;
    width: 100%;
    margin-bottom: 12px;
    padding: 12px;
    border-radius: $border-radius-root;
    border: 1px solid rgba($secondary-500, 0.3);
    background-color: rgba($secondary-500, 0.05);

    b {
        color: $secondary-500;
    }
}
</style>
